/* eslint-disable no-unused-vars */
import { post } from "../config";

//====================================================
// login api
export function GetCustomerDetail({ body }) {
  const token = sessionStorage.getItem("authToken");
  return post({
    url: `/api/aunjai/customerDetail`,
    body,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

// สมัครสมาชิก
export function CreateCustomer({ body }) {
  return post({ url: `/api/aunjai/createCustomer`, body });
}

export function CheckCustomer({ body }) {
  return post({ url: `/api/aunjai/checkCustomer`, body });
}

export function RequestCustomer({ body }) {
  return post({ url: `/api/aunjai/requestCustomer`, body });
}

export function checkCustomerByPhone(phone) {
  return post({ url: `/api/aunjai/checkCustomerByPhone`, body: { phone } });
}
